import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Box } from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const searchData = this.props.selectedSearchValues;
        const reportData = this.props.reportData;
        const contentRowNames = this.props.contentRowNames;
        const fullLeafTotal = this.props.fullLeafTotal;
        const fullDayCount = this.props.fullDayCount;
        const fullPluckingAvg = this.props.fullPluckingAvg;
        const fullNameCount = this.props.fullNameCount;
        const totalRow = this.props.totalRow;
        return (
            <div>
                <h3><center><u>Daily Plucking Average Analysis Registered Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Month: </b> {searchData.month}</div>
                </div>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <TableContainer>
                        <Table
                            aria-labelledby="tableTitle"
                            aria-label="enhanced table">
                            <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Estate</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Division</TableCell>
                                    {contentRowNames.map((item) => (
                                        (item == 26 ?
                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>{'>26'}</TableCell>
                                            :
                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>{item}</TableCell>
                                        )
                                    ))}
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Names on Ch.Roll</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>M&W Days Plucking</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Leaf(kg)</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>Plucking Avg</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row) => {
                                    let pluckingAvgTotalAll = 0;
                                    let LeafTotalAll = 0
                                    return (
                                        <>
                                            {row.dataList.map((column) => {
                                                let LeafTotal = 0;
                                                let nameCount = 0;
                                                let dayCount = 0;
                                                let pluckingAvg = 0;
                                                return (
                                                    <>
                                                        <TableRow >
                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }}>{row.operationEntityName}</TableCell>
                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold" }} >{column.collectionPointName}</TableCell>
                                                            {contentRowNames.map((item) => {
                                                                const value = column.dataList.filter(x => x.range == item)
                                                                nameCount += value.length;
                                                                let total = 0;
                                                                value.forEach(x => {
                                                                    total += x.amount;
                                                                    LeafTotal += x.totalAmount;

                                                                })
                                                                dayCount += total
                                                                pluckingAvg = LeafTotal / dayCount
                                                                pluckingAvgTotalAll += pluckingAvg
                                                                LeafTotalAll += LeafTotal
                                                                return (
                                                                    value.length == 0 ?
                                                                        <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>
                                                                            {'-'}
                                                                        </TableCell> :
                                                                        <>
                                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>
                                                                                {total}
                                                                            </TableCell>
                                                                        </>
                                                                );
                                                            })}
                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{column.namecount}</TableCell>
                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{dayCount}</TableCell>
                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{LeafTotal}</TableCell>
                                                            <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{pluckingAvg.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    </>
                                                );
                                            })}
                                        </>
                                    );
                                })}
                                <TableRow style={{ border: "2px solid black", fontWeight: "bold" }}>
                                    <TableCell colSpan={2} style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} align='center' >Total</TableCell>
                                    {contentRowNames.map((item) => {
                                        const value = totalRow.filter(x => x.name == item)
                                        let tot = 0;
                                        value.forEach(x => {
                                            tot += x.val
                                        })
                                        return (
                                            value.length == 0 ?
                                                <TableCell style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} align='center'>
                                                    {'-'}
                                                </TableCell> :
                                                <>
                                                    <TableCell style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} align='center'>{tot}</TableCell>
                                                </>
                                        );
                                    })}
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullNameCount}</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }} >{fullDayCount}</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullLeafTotal}</TableCell>
                                    <TableCell align='center' style={{ border: "2px solid black", fontWeight: "bold", fontSize: '14px' }}>{fullPluckingAvg.toFixed(2)}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}